export default __webpack_public_path__ + "static/media/wh_ep2_wenny_stare.e125dff2.png";